export function localStorageGetItem(key: string): string | null {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

export function localStorageSetItem(key: string, value: string): void {
  try {
    localStorage.setItem(key, value)
  } catch {
    // Storage may be unavailable in private browsing, revoked permissions, or managed environments
  }
}

export function localStorageRemoveItem(key: string): void {
  try {
    localStorage.removeItem(key)
  } catch {
    // Storage may be unavailable in private browsing, revoked permissions, or managed environments
  }
}
